import { useSnackbar } from "@saas-ui/react";
import { useCallback } from "react";

export const useError = () => {
  const toast = useSnackbar();

  const handleError = useCallback(
    (error?: any) => {
      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message;

      if (process.env.NODE_ENV !== "production") {
        console.error("useError():", error);
      }

      toast({
        title: message,
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    },
    [toast]
  );

  return {
    handleError,
  };
};
